const customer = () => import('@/views/main/customer/customer.vue')
export default {
  path: '/main/customer',
  name: 'customer',
  component: customer,
  children: []
}
